import axios from '@/api/axiosInstance';

export default async function resendVerificationEmail() {
  const response = await axios({
    method: 'post',
    url: `${process.env.NEXT_PUBLIC_API}/auth/resendVerificationEmail`,
  });

  return response.data;
}
